import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { faTriangleExclamation, faXmark, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import {RoleService} from "../../../data-access/role.service";
import {SubjectsModel} from "../../../data-access/subjects.model";
import * as url from "url";
import {SystemManagementService} from "../../../data-access/system-management.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";

interface Item {
  name: string
  organization_id: number
  subject_id: number
}
@Component({
    selector: 'system-config',
    templateUrl: './system-config.component.html',
    styleUrls: ['../../userManagement/userRoleAddEdit/userRoleAddEdit.css'],
    standalone: false
})
export class SystemConfigComponent implements OnInit {
  router = inject(Router)
  systemService = inject(SystemManagementService)
  route = inject(ActivatedRoute)
  _snackBar = inject(MatSnackBar)
  configName = ''
  unitID = ''
  orgID = ''
  subjectID  = ''
  name = ''
  editOrgID: number | undefined = undefined
  editSubjectID: number | undefined = undefined
  editCourseID: number | undefined = undefined
  editUnitID: number | undefined = undefined
  items: Item[] = []
  startDate: Date | undefined = undefined
  endDate: Date | undefined = undefined
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'System Management',
    route: 'dashboard/SystemManagement'
  }, {
    text: '',
    route: ''
  }]
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if(window.location.pathname.includes('organizations')) {
        this.configName = 'Organization'
        if(params['organization_id']) {
          this.editOrgID = params['organization_id']
          this.name = params['name']
        }
      } else if(window.location.pathname.includes('courses')) {
        this.configName  = 'Course'
        if(params['course_id']) {
          this.editCourseID = params['course_id']
          this.name = params['name']
          this.unitID = params['unit_id']
          this.startDate = params['start']
          this.endDate = params['end']
        }
        this.systemService.listUnits().subscribe((response) => {
          if(response.success) {
            this.items = response.result.items
          } else {
            this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
          }
        })
      } else if(window.location.pathname.includes('subjects')) {
        this.configName = 'Subject'
        if(params['subject_id']) {
          this.name = params['name']
          this.editSubjectID = params['subject_id']
          this.orgID = params['organization_id']
        }
        this.systemService.listOrgs().subscribe((response) => {
          if(response.success) {
            this.items = response.result.items
          } else {
            this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
          }
        })
      } else if(window.location.pathname.includes('units')) {
        this.configName = 'Unit'
        if(params['unit_id']) {
          this.editUnitID = params['unit_id']
          this.name = params['name']
          this.subjectID = params['subject_id']
        }
        this.systemService.listSubjects().subscribe((response) => {
          if(response.success) {
            this.items = response.result.items
          } else {
            this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
          }
        })
      }
      this.breadcrumbNavs[1].text = `${this.configName} List`
      if(this.configName === 'Organization')
        this.breadcrumbNavs[0].route = 'dashboard/SystemManagement/organizations'
      else if(this.configName === 'Course')
        this.breadcrumbNavs[0].route = 'dashboard/SystemManagement/courses'
      else if(this.configName === 'Subject')
        this.breadcrumbNavs[0].route = 'dashboard/SystemManagement/subjects'
      else if(this.configName === 'Unit')
        this.breadcrumbNavs[0].route = 'dashboard/SystemManagement/units'
    })
  }

  cancelConfig() {
    this.router.navigate(['../'], {relativeTo: this.route})
  }

  submitConfig() {
    if(this.configName === 'Organization') {
      this.systemService.createOrg(this.name, this.editOrgID).subscribe((response) => {
        if(response.success) {
          if(this.editOrgID != undefined)
            this._snackBar.open('Organization edited successfully', 'Dismiss')
          else
            this._snackBar.open('Organization created successfully', 'Dismiss')
          this.cancelConfig()
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
    }
    else if(this.configName === 'Course') {
      this.systemService.createCourse(this.name, Number(this.unitID), this.editCourseID, this.startDate, this.endDate).subscribe((response) => {
        if(response.success) {
          if(this.editCourseID != undefined)
            this._snackBar.open('Course edited successfully', 'Dismiss')
          else
            this._snackBar.open('Course created successfully', 'Dismiss')
          this.cancelConfig()
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
    }
    else if(this.configName === 'Subject') {
      this.systemService.createSubject(this.name, Number(this.orgID), this.editSubjectID).subscribe((response) => {
        if(response.success) {
          if(this.editSubjectID != undefined)
            this._snackBar.open('Subject edited successfully', 'Dismiss')
          else
            this._snackBar.open('Subject created successfully', 'Dismiss')
          this.cancelConfig()
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
    }
    else if(this.configName === 'Unit') {
      this.systemService.createUnit(this.name, Number(this.subjectID), this.editUnitID).subscribe((response) => {
        if(response.success) {
          if(this.editUnitID != undefined)
            this._snackBar.open('Unit edited successfully', 'Dismiss')
          else
            this._snackBar.open('Unit created successfully', 'Dismiss')
          this.cancelConfig()
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
    }
  }
}
